import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ error: $props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name] && $props.v$.value[$props.propname ?? $props.name].$errors.length })
    }, [
      _createVNode(_component_Password, {
        id: $props.name,
        name: $props.name,
        disabled: $props.Isdisabled,
        modelValue: $props.modelValue,
        placeholder: $props.placeholder,
        feedback: $props.feedback,
        toggleMask: $props.toggleMask,
        propname: $props.propname,
        class: "w-full",
        ref: "InputValue",
        onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateValue($event.target.value)))
      }, {
        footer: _withCtx((sp) => [
          _createTextVNode(_toDisplayString(sp.level) + " ", 1 /* TEXT */),
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "m-0 mb-2" }, "Requirements", -1 /* CACHED */)),
          _cache[2] || (_cache[2] = _createElementVNode("ul", {
            class: "pl-2 ml-2 mt-0",
            style: {"line-height":"1.5"}
          }, [
            _createElementVNode("li", null, "Minimum 6 characters long"),
            _createElementVNode("li", null, "At least one lowercase character"),
            _createElementVNode("li", null, "At least one uppercase character"),
            _createElementVNode("li", null, "At least one number"),
            _createElementVNode("li", null, "At least 1 special character")
          ], -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["id", "name", "disabled", "modelValue", "placeholder", "feedback", "toggleMask", "propname"])
    ], 2 /* CLASS */),
    ($props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.v$.value[$props.propname ?? $props.name].$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(error.$message), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}